var saveData = JSON.parse(localStorage.saveData || null) || {};
var state = {
    gender : null,
    subcollection : null,
    color_code : null,
    side : "F"
};

var feed_html = null;

var collection = {
    init : function () {
        var self = this;

        this.initStickyMenu();

        feed_html = $('#feed').html();

        if(saveData.selectedColor) {
            self.setColor(saveData.selectedColor);
        }
        if(saveData.selectedSide){
            self.setSide(saveData.selectedSide);
        }

        $('.checkbox button').click(function (e) {
            e.preventDefault();
            var side = $(e.target).data("side");
            self.setSide(side);
        });

        $('#color-select').change(function (e) {
            e.preventDefault();
            self.setColor(e.target.value);
        });

        $('#gender-select a').click(function (e) {
            e.preventDefault();
            $(e.target).toggleClass('active');
            var gender = $(e.target).data("gender");
            
            if(gender == state.gender ){
                return;
            }else{
                $('#gender-select a').removeClass('active');
                $(e.target).addClass('active');
                state.gender = gender == 'all' ? null : gender;
            }
            self.setView();
        });

        $('#collection-select a').click(function (e) {
            e.preventDefault();

            var subcollection = $(e.target).data("subcollection");

            if(subcollection == state.subcollection || subcollection == 'all'){
                return;
            }else{
                $('#collection-select a').removeClass('active');
                $(e.target).addClass('active');
                state.subcollection = subcollection == 'all' ? null : subcollection;
            }
            self.setView();
        });

        $('#feed .glasses a').click(function (e) {
            if(!saveData.selectedColor) {
                e.preventDefault();
                saveData.selectedColor = $(e.target).parent().data('color');
                localStorage.saveData = JSON.stringify(saveData);
                location.href = $(e.target).attr('href');
            }
        });


    },

    initDetailPage : function () {
        var self = this;

        if(saveData.selectedColor) {
            self.setColor(saveData.selectedColor);
        }
        if(saveData.selectedSide){
            self.setSide(saveData.selectedSide);
        }

        $('.checkbox button').click(function (e) {
            e.preventDefault();
            var side = $(e.target).data("side");
            self.setSide(side);
        });

        $('#color-select').change(function (e) {
            e.preventDefault();
            self.setColor(e.target.value);
        });
    },

    setView: function () {
        $('#feed').html(feed_html);

        this.setColor(state.color_code);
        this.setSide(state.side);

        this.selectGender(state.gender);
        this.selectSubcollection(state.subcollection);

        $('.count').html($('.glasses').length );

    },

    setViewDetail: function () {
        this.setColor(state.color_code);
        this.setSide(state.side);
    },

    setColor: function (color_code) {
        if(color_code == null)
            return;

        $('#color-select').val(color_code).trigger('change.select2');

        var side = saveData.selectedSide ? saveData.selectedSide : 'F';

        $('.glasses img, .big-glasses img').each(function () {
            var id = $(this).parent().data('id');

            if(color_code == 'random'){
                var img_url = window.rb_data.collection[id-1].images[side][$(this).parent().data('color')];
            }else{
                var img_url = window.rb_data.collection[id-1].images[side][color_code];
            }

            try{
                $(this).attr('src',img_url);
            }catch(e){
                // console.log(e);
            }
        });



        saveData.selectedColor = color_code == 'random' ? null : color_code;
        localStorage.saveData = JSON.stringify(saveData);
        state.color_code = color_code;

    },

    setSide: function (side) {
        if(side == null)
            return;

        $('.checkbox button').removeClass('checked');
        $('.checkbox button[data-side="'+ side + '"]').addClass('checked');

        $('.glasses img, .big-glasses img').each(function () {
            var id = $(this).parent().data('id');

            var color_code = saveData.selectedColor && saveData.selectedColor != 'random' ? saveData.selectedColor : $(this).parent().data('color');

            var img_url = window.rb_data.collection[id-1].images[side][color_code];

            $(this).attr('src',img_url);
        });

        saveData.selectedSide = side;
        localStorage.saveData = JSON.stringify(saveData);
        state.side = side;
    },

    selectGender: function(gender){
        if(gender == null)
            return;

        $('#feed > div').not('.glasses[data-gender="'+gender+'"]').remove();

        state.gender = gender;
    },

    selectSubcollection: function(subcollection){
        if(subcollection == null)
            return;

        $('#feed > div').not('.glasses[data-subcollection="'+subcollection+'"]').remove();
        state.subcollection = subcollection;
    },

    initStickyMenu: function() {
        return;
        var controllerSticky = new ScrollMagic.Controller();

        var duration = $('.left-nav-container--content').outerHeight() -  $('.left-nav').outerHeight() + 20;

        new ScrollMagic.Scene({
            triggerElement: "#top-sticky",
            offset: -70,
            triggerHook: "onLeave",
            duration: duration
        })
            .setPin("#left-sticky")
            .setClassToggle("#left-nav", "bottom") // add class toggle
            .addTo(controllerSticky);

        new ScrollMagic.Scene({
            triggerElement: "#top-sticky",
            offset: -70,
            triggerHook: "onLeave",
            duration: duration
        })
            .setPin("#top-sticky")
            .addTo(controllerSticky);

    }

};
